module.exports = __webpack_public_path__ + "img/06.19108a85.png";